import React from "react";
import {PanelEditRole} from "../../../UI/Roles/Edit/PanelEditRole";

const EditRole = () => {
  return (
    <div>
      <PanelEditRole />
    </div>
  );
};

export default React.memo(EditRole);

